// src/utils/Mensaje.js
import Swal from "sweetalert2";

/**
 * Muestra un SweetAlert con el mensaje recibido.
 * @param {string} texto - El texto a mostrar.
 * @param {"success"|"error"|"info"|"warning"|"question"} [icon="success"] - Tipo de icono.
 * @param {number} [timer=2000] - Duración en milisegundos.
 */
export function mostrarMensaje(texto, icon = "success", timer = 2000) {
  if (!texto) return;
  Swal.fire({
    icon,
    title: texto,
    timer,
    showConfirmButton: false,
  });
}
